import {useMutation} from '@apollo/react-hooks';

import type {
    ConnectedFormActivate as ConnectedFormActivateMutation,
    ConnectedFormActivateVariables as ConnectedFormActivateMutationVariables,
    ConnectedFormActivateInput,
} from 'nutshell-graphql-types';

import WF_FORM_FRAGMENT from '../graphql/fragments/wf-form-fragment.graphql';
import CONNECTED_FORM_ACTIVATE from '../graphql/mutations/connected-form-activate.graphql';

export function useActivateForm(): (arg1: ConnectedFormActivateInput) => Promise<any> {
    const [activateForm] = useMutation<
        ConnectedFormActivateMutation,
        ConnectedFormActivateMutationVariables
    >(CONNECTED_FORM_ACTIVATE);

    return (input: ConnectedFormActivateInput) => {
        return activateForm({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment.
                const formFragment = proxy.readFragment({
                    id: input.wfFormId,
                    fragmentName: 'WfFormFragment',
                    fragment: WF_FORM_FRAGMENT,
                });

                if (formFragment) {
                    const updatedForm =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.connectedFormActivate &&
                        mutationResults.data.connectedFormActivate.connectedForm;

                    if (!updatedForm) return;

                    proxy.writeFragment({
                        id: input.wfFormId,
                        fragmentName: 'WfFormFragment',
                        fragment: WF_FORM_FRAGMENT,
                        data: updatedForm,
                    });
                }
            },
        });
    };
}
